module.exports = __webpack_public_path__ + "static/confetti-stamps-large-fe2bf62303da60ce6b0659912bb74c24.svg";